import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  Avatar,
  Button,
  Icon,
  ListItemIcon,
  ListItemText,
  Popover,
  Typography,
  MenuItem
} from '@material-ui/core';

// local imports
import { AuthService } from 'app/services';
import { roleNameMapper } from 'app/utils/mapper';

function UserMenu() {
  const user = useSelector(({ auth: { user } }) => user.data);
  const userRoles = useSelector(({ auth: { user } }) => user.roles);
  const [userMenu, setUserMenu] = useState(null);
  const userRoleId = user?.role_id;
  const userRoleName = roleNameMapper(userRoleId, userRoles);

  const userMenuClick = event => setUserMenu(event.currentTarget);
  const userMenuClose = () => setUserMenu(null);

  const handleLogout = () => {
    // dispatch(logoutUser());
    AuthService.logout();
    userMenuClose();
  };

  const PopoverProps = {
    open: Boolean(userMenu),
    anchorEl: userMenu,
    onClose: userMenuClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    classes: {
      paper: 'py-8'
    }
  };

  const apiURL = process.env.REACT_APP_API;
  const photoSrc = user?.photo_url
    ? `${apiURL}/${user?.photo_url}`
    : 'assets/images/avatars/profile.jpg';

  return (
    <>
      <Button className="min-h-40 min-w-40 px-0 md:px-16 py-0 md:py-6" onClick={userMenuClick}>
        <div className="hidden md:flex flex-col mx-4 items-end">
          <Typography component="span" className="font-semibold flex">
            {user?.name} {user?.surname}
          </Typography>
          <Typography className="text-11 font-medium capitalize" color="textSecondary">
            {userRoleName || '-'}
          </Typography>
        </div>

        {user?.photo_url ? (
          <Avatar className="md:mx-4" alt="user photo" src={photoSrc} />
        ) : (
          <Avatar className="md:mx-4">{user?.name[0] || 'A'}</Avatar>
        )}
      </Button>

      <Popover {...PopoverProps}>
        <MenuItem component={Link} to="/profile" onClick={userMenuClose} role="button">
          <ListItemIcon className="min-w-40">
            <Icon>account_circle</Icon>
          </ListItemIcon>
          <ListItemText primary="Profil" />
        </MenuItem>

        <MenuItem onClick={handleLogout}>
          <ListItemIcon className="min-w-40">
            <Icon>exit_to_app</Icon>
          </ListItemIcon>
          <ListItemText primary="Çıkış Yap" />
        </MenuItem>
      </Popover>
    </>
  );
}

export default UserMenu;
